import * as _ from 'lodash';

function getPageParam(name) {
    if (name = (new RegExp('[?&]' + encodeURIComponent(name) + '=([^&]*)')).exec(location.search))
        return decodeURIComponent(name[1]);
}

let shopName = getPageParam("shop");

// TODO: this line should be removed in production
let url = window.CARTONOMY_API_URL || 'https://apipartner1.cartonomy.com/api/';

let backendEndPoint = url.substr(0, url.lastIndexOf('/api'));

let cartonomyConfig = {
    backendEndPoint: backendEndPoint,
    ApiV1: url + 'v1/',
    ApiV2: url + 'v2/',
    version: '@version@',
    buildTime: '@buildTime@',
    externalStoreMode: window.EXTERNAL_STORE_MODE || false,
    externalStoreUrl: shopName,
    getPageParam: getPageParam
};

export default cartonomyConfig;



// WEBPACK FOOTER //
// ./src/bootstrap/cartonomy_config.js